import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { map } from 'rxjs/operators';
import { SharedDataService } from 'src/app/services/shared-data-service.service';
import { SharedData } from '../../model/shared-data.model';
import { ContactInfoService } from '../../services/contact-info.service';

@Component({
  selector: 'contact-type-select',
  templateUrl: './contact-type-select.component.html',
  styleUrls: ['./contact-type-select.component.css']
})
export class ContactTypeSelectComponent implements OnInit {
  @Input() contactType: string;
  @Output() changeEvent = new EventEmitter<string>(true);

  @Input() availableTypes: string[];
  sharedData: SharedData;

  constructor(private contactInfoService: ContactInfoService,sharedService: SharedDataService) {
    this.sharedData = sharedService.getData();
  }

  ngOnInit(): void {
    
  }

  onValueChange(event: any) {
    this.changeEvent.emit(this.contactType);
  }

}
